import { createSlice } from '@reduxjs/toolkit';

// Per-user localStorage key for the globally selected project.
const STORAGE_KEY_PREFIX = 'fieldtime_selected_project_';

export const getProjectStorageKey = (userId) =>
  `${STORAGE_KEY_PREFIX}${userId}`;

/**
 * Read the stored project for a user. Returns the parsed
 * { id, number, name, default_trade_id } object, or null if nothing is stored
 * or parsing fails.
 */
export const readStoredProject = (userId) => {
  if (!userId) return null;
  try {
    const raw = localStorage.getItem(getProjectStorageKey(userId));
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const writeStoredProject = (userId, project) => {
  if (!userId) return;
  try {
    localStorage.setItem(getProjectStorageKey(userId), JSON.stringify(project));
  } catch {
    // Ignore quota / serialization errors — Redux state remains the source of truth.
  }
};

export const removeStoredProject = (userId) => {
  if (!userId) return;
  try {
    localStorage.removeItem(getProjectStorageKey(userId));
  } catch {
    // Ignore.
  }
};

const initialProjectState = {
  selectedProject: null, // { id, number, name, default_trade_id } or null
  isDrawerOpen: false,
};

const projectSlice = createSlice({
  name: 'project',
  initialState: initialProjectState,
  reducers: {
    selectProject(state, action) {
      const { id, number, name, default_trade_id } = action.payload;
      // default_trade_id pre-fills Trade in the New Package modal
      state.selectedProject = {
        id,
        number,
        name,
        default_trade_id: default_trade_id || null,
      };
    },
    clearProject(state) {
      state.selectedProject = null;
    },
    openProjectDrawer(state) {
      state.isDrawerOpen = true;
    },
    closeProjectDrawer(state) {
      state.isDrawerOpen = false;
    },
  },
});

export const projectActions = projectSlice.actions;

export default projectSlice.reducer;
